module.exports = __webpack_public_path__ + "img/901693285.a250673d.png";